import { Formik, FormikConfig } from 'formik';
import React, { forwardRef, useImperativeHandle } from 'react';

function PropertyPalFormikWithRef(props: FormikConfig<any>, ref: React.Ref<any>) {
  let formikPropObj = {};

  const { onSubmit, ...rest } = props;

  useImperativeHandle(ref, () => formikPropObj);

  return (
    <Formik {...rest} onSubmit={onSubmit}>
      {(formikProps) => {
        formikPropObj = formikProps;
        if (typeof props.children === 'function') {
          return props.children(formikProps);
        }
        return props.children;
      }}
    </Formik>
  );
}

export default forwardRef(PropertyPalFormikWithRef);
